import { Map, List } from "immutable";

import {
  PARTNERSHIP_LIST_REQUEST,
  PARTNERSHIP_LIST_SUCCESS,
  PARTNERSHIP_LIST_FAILURE,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function partnerships(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    "debug",
    `[partnerships.reducers] partnerships(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case PARTNERSHIP_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case PARTNERSHIP_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.order, action.limit, action.page],
          List(action.result)
        );

    case PARTNERSHIP_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });
    default:
      return state;
  }
}

Logger.log("silly", `partnerships.reducers loaded.`);
